<template>
  <div @scroll.passive="handleScroll">
<br><br>
    <!-- BANDEAU « À LA UNE » (publication cochée « À la une » dans l'admin) -->
<div v-if="aLaUne" class="recrutement-banner">
  <div class="container">

    <i class="bi" :class="iconeALaUne"></i>

    <div class="text">
      <strong>{{ aLaUne.titre }}</strong>
      <span v-if="aLaUne.extrait">{{ aLaUne.extrait }}</span>
    </div>

    <router-link :to="`/actualites/${aLaUne.slug}`" class="btn">
      {{ aLaUne.categorie === 'recrutement' ? 'Voir l’offre' : 'En savoir plus' }}
    </router-link>

  </div>
</div>
  <!-- HERO -->
<section
  class="hero-section"
  @mousemove="handleMouseMove"
>

  <!-- SLIDER -->
  <div class="hero-slider">

    <div
      v-for="(slide, i) in slides"
      :key="i"
      class="hero-slide"
      :style="{
        backgroundImage: `url(${slide})`,
        transform: `translate3d(${parallax.x}px, ${parallax.y}px, 0)`
      }"
      :class="{ active: i === currentSlide }"
    ></div>

  </div>

  <!-- OVERLAY -->
  <div class="hero-overlay"></div>

  <!-- GOLD LIGHT -->
  <div class="hero-light"></div>

  <!-- CONTENT -->
  <div class="container hero-container">

    <div
      class="hero-content"
      data-aos="fade-up"
    >

      <!-- BADGE -->
      <div class="hero-badge">
        <i class="bi bi-stars"></i>
        Groupe Multisectoriel au Mali
      </div>

      <!-- LOGO -->
      <div class="hero-logo-wrapper">
        <img
          src="@/assets/logo_groupeviras.jpeg"
          class="hero-logo"
          alt="Logo Groupe VIRAS"
        />
      </div>

      <!-- TITLE -->
      <h1 class="hero-title">
        <span
          v-for="(letter, index) in titleLetters"
          :key="index"
          :style="{ animationDelay: (index * 0.05) + 's' }"
        >
          {{ letter }}
        </span>
      </h1>

      <!-- SUBTITLE -->
      <p class="hero-subtitle">
        Innovation • Expertise • Excellence
        <br>
        au service de plusieurs secteurs stratégiques
      </p>

      <!-- ACTIONS -->
      <div class="hero-actions">

        <router-link
          to="/services"
          class="hero-btn primary-btn"
        >
          <i class="bi bi-grid-fill"></i>
          Découvrir nos services
        </router-link>

        <router-link
          to="/contact"
          class="hero-btn secondary-btn"
        >
          <i class="bi bi-envelope-fill"></i>
          Nous contacter
        </router-link>

      </div>

      <!-- STATS -->
      <div class="hero-stats">

        <div class="hero-stat">
          <h4>9 Pôles & Filiales</h4>
          <span>Filiales</span>
        </div>

        <div class="hero-stat">
          <h3>5000+</h3>
          <span>Clients</span>
        </div>

        <div class="hero-stat">
          <h3>10+</h3>
          <span>Années</span>
        </div>

      </div>

    </div>

  </div>

  <!-- SCROLL -->
  <div class="hero-scroll">
    <span></span>
  </div>

  <!-- CONTROLS -->
  <div class="hero-controls">

    <button @click="prevSlide">
      <i class="bi bi-chevron-left"></i>
    </button>

    <button @click="nextSlide">
      <i class="bi bi-chevron-right"></i>
    </button>

  </div>

</section>
    <!-- À PROPOS -->
 <!-- À PROPOS -->
<section
  class="about-section"
  :style="{ transform: `translateY(${scrollOffset*0.03}px)` }"
>

  <!-- BACKGROUND SHAPES -->
  <div class="about-shape shape-1"></div>
  <div class="about-shape shape-2"></div>

  <div class="container about-container">

    <!-- IMAGE SIDE -->
    <div
      class="about-visual"
      data-aos="fade-right"
    >

      <!-- MAIN IMAGE -->
      <div class="about-main-image">

        <img
          src="@/assets/groupe viras.png"
          alt="Groupe VIRAS Mali"
          loading="lazy"
        />

        <!-- FLOATING CARD -->
        <div class="about-floating-card">

          <div class="floating-icon">
            <i class="bi bi-buildings-fill"></i>
          </div>

          <div>
            <h3>9 Pôles & Filiales</h3>
            <p>Un groupe multisectoriel innovant</p>
          </div>

        </div>

      </div>

      <!-- SMALL IMAGES -->
      <div class="about-mini-gallery">

        <div class="mini-card">
          <img src="@/assets/ramadan-mali-white-background.jpg" />
        </div>

        <div class="mini-card">
          <img src="@/assets/asian-food-restaurant.jpg" />
        </div>

        <div class="mini-card">
          <img src="@/assets/silhouette-man-mountain.jpg" />
        </div>

      </div>

    </div>

    <!-- TEXT SIDE -->
    <div
      class="about-content"
      data-aos="fade-left"
    >

      <!-- BADGE -->
      <div class="about-badge">
        <i class="bi bi-stars"></i>
        GROUPE MULTISECTORIEL AU MALI
      </div>

      <!-- TITLE -->
      <h2 class="about-title">
        À propos du
        <span>Groupe VIRAS</span>
      </h2>

    <!-- DESCRIPTION -->
<p class="about-description">
  Le <strong>Groupe VIRAS</strong> est un groupe multidisciplinaire
  basé à <strong>Bamako, Mali</strong>, intervenant dans plusieurs
  secteurs stratégiques :
  le tourisme, la santé, la gastronomie,
  le consulting, la formation professionnelle,
  la mode de luxe et les services technologiques innovants.
</p>

<p class="about-description">
  Grâce à ses différentes filiales et pôles d’expertise,
  le Groupe VIRAS accompagne les entreprises,
  institutions et particuliers avec des solutions modernes,
  fiables et adaptées aux standards internationaux.
  Il intègre notamment <strong>Maison VIRAS</strong>, sa marque de luxe
  dédiée à la mode, la couture et aux accessoires haut de gamme,
  ainsi qu’un pôle technologique orienté vers les solutions digitales
  et l’innovation.
</p>

<!-- FEATURES -->
<div class="about-features">

  <div class="feature-card">
    <div class="feature-icon">
      <i class="bi bi-lightbulb-fill"></i>
    </div>

    <div>
      <h4>Innovation</h4>
      <p>Des solutions modernes adaptées au marché africain.</p>
    </div>
  </div>

  <div class="feature-card">
    <div class="feature-icon">
      <i class="bi bi-diagram-3-fill"></i>
    </div>

    <div>
      <h4>Expertise</h4>
      <p>Une expertise multisectorielle et professionnelle.</p>
    </div>
  </div>

  <div class="feature-card">
    <div class="feature-icon">
      <i class="bi bi-people-fill"></i>
    </div>

    <div>
      <h4>Accompagnement</h4>
      <p>Un suivi personnalisé pour chaque partenaire.</p>
    </div>
  </div>

  <div class="feature-card">
    <div class="feature-icon">
      <i class="bi bi-globe2"></i>
    </div>

    <div>
      <h4>Vision internationale</h4>
      <p>Une ouverture vers les standards internationaux.</p>
    </div>
  </div>

  <!-- NOUVEAUX BLOCS -->

  <div class="feature-card">
    <div class="feature-icon">
      <i class="bi bi-gem"></i>
    </div>

    <div>
      <h4>Maison VIRAS</h4>
      <p>Une maison de luxe dédiée à la mode, au prestige et à l’élégance africaine.</p>
    </div>
  </div>

  <div class="feature-card">
    <div class="feature-icon">
      <i class="bi bi-cpu-fill"></i>
    </div>

    <div>
      <h4>Technologie</h4>
      <p>Développement de solutions digitales et plateformes innovantes.</p>
    </div>
  </div>

</div>

      <!-- BUTTONS -->
      <div class="about-actions">

        <router-link
          to="/groupe"
          class="about-btn primary-btn"
        >
          <i class="bi bi-arrow-right-circle-fill"></i>
          En savoir plus
        </router-link>

        <router-link
          to="/contact"
          class="about-btn secondary-btn"
        >
          <i class="bi bi-envelope-fill"></i>
          Nous contacter
        </router-link>

      </div>

    </div>

  </div>

</section>

    <!-- FILIALES SLIDER -->
   <!-- FILIALES -->
<section class="section section-light filiales-section">
  <div class="container">

    <h2 class="section-title" data-aos="fade-up">
      Nos Filiales
    </h2>

    <p class="section-subtitle" data-aos="fade-up" data-aos-delay="100">
      Un écosystème d’expertise couvrant plusieurs secteurs stratégiques
    </p>

    <div class="filiales-grid">

      <div
        v-for="(filiale, index) in filiales"
        :key="index"
        class="filiale-card"
        data-aos="zoom-in"
        :data-aos-delay="index*120"
      >

        <div class="filiale-bg"></div>

        <div class="filiale-content">

          <div class="filiale-logo">
            <img :src="filiale.logo" />
          </div>

          <!--<div class="filiale-icon">
  <i :class="filiale.icon"></i>
</div>-->

          <h3 class="filiale-title">
            {{ filiale.title }}
          </h3>

          <p class="filiale-description">
            {{ filiale.description }}
          </p>

          <router-link :to="filiale.route" class="filiale-btn">
  Découvrir →
</router-link>

        </div>

      </div>

    </div>

  </div>
</section>

    <!-- EXPERTISE -->
    <section class="section section-fancy">
      <div class="container">
        <h2 class="section-title" data-aos="fade-up">Nos Domaines d’Expertise</h2>
        <div class="grid grid-3 expertise-grid">
          <div 
            v-for="(expert, i) in expertise" 
            :key="i" 
            class="expertise-CardView hover-3d glow" 
            data-aos="fade-up" 
            :data-aos-delay="i*100"
            :style="{ transform: `translateY(${scrollOffset*0.02}px)` }"
          >
            <div class="expert-icon">
  <i :class="expert.icon"></i>
</div>
            <div class="expert-title">{{ expert.title }}</div>
          </div>
        </div>
      </div>
    </section>

   <!-- POURQUOI VIRAS -->
<section class="section section-light why-section">
  <div class="container">

    <div class="section-header" data-aos="fade-up">
      <span class="section-badge">
        NOS ENGAGEMENTS
      </span>

      <h2 class="section-title">
        Pourquoi choisir le Groupe VIRAS
      </h2>

      <p class="section-subtitle">
        Un groupe multisectoriel engagé pour l’excellence,
        l’innovation et la satisfaction de ses partenaires.
      </p>
    </div>

    <div class="why-grid">

      <!-- CARD -->
      <div
        class="why-card"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <div class="why-icon">
          <i class="bi bi-rocket-takeoff-fill"></i>
        </div>

        <h3>Innovation</h3>

        <p>
          Nous développons des solutions modernes adaptées aux réalités
          africaines et aux besoins des entreprises et institutions.
        </p>
      </div>

      <!-- CARD -->
      <div
        class="why-card"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div class="why-icon">
          <i class="bi bi-people-fill"></i>
        </div>

        <h3>Partenariat durable</h3>

        <p>
          Nous travaillons en étroite collaboration avec nos clients
          afin de construire des relations solides et durables.
        </p>
      </div>

      <!-- CARD -->
      <div
        class="why-card"
        data-aos="fade-up"
        data-aos-delay="300"
      >
        <div class="why-icon">
          <i class="bi bi-globe2"></i>
        </div>

        <h3>Vision internationale</h3>

        <p>
          Nos services combinent expertise locale et ouverture vers
          les standards et opportunités internationales.
        </p>
      </div>

      <!-- CARD -->
      <div
        class="why-card"
        data-aos="fade-up"
        data-aos-delay="400"
      >
        <div class="why-icon">
          <i class="bi bi-award-fill"></i>
        </div>

        <h3>Excellence</h3>

        <p>
          Nous visons les plus hauts standards de qualité dans
          chacun de nos projets et prestations.
        </p>
      </div>

      <!-- CARD -->
      <div
        class="why-card"
        data-aos="fade-up"
        data-aos-delay="500"
      >
        <div class="why-icon">
          <i class="bi bi-shield-check"></i>
        </div>

        <h3>Fiabilité</h3>

        <p>
          Nos équipes assurent un accompagnement professionnel,
          transparent et orienté résultats.
        </p>
      </div>

      <!-- CARD -->
      <div
        class="why-card"
        data-aos="fade-up"
        data-aos-delay="600"
      >
        <div class="why-icon">
          <i class="bi bi-lightning-charge-fill"></i>
        </div>

        <h3>Réactivité</h3>

        <p>
          Nous répondons rapidement aux besoins de nos partenaires
          avec efficacité et professionnalisme.
        </p>
      </div>

    </div>

  </div>
</section>
<!-- STATISTIQUES -->
<section class="section stats-section">
  <div class="container">

    <div class="stats-grid">

      <div class="stat">
        <h3>10+</h3>
        <p>Années d'expérience</p>
      </div>

      <div class="stat">
        <h3>4</h3>
        <p>Filiales</p>
      </div>

      <div class="stat">
        <h3>5000+</h3>
        <p>Clients accompagnés</p>
      </div>

      <div class="stat">
        <h3>20+</h3>
        <p>Partenaires stratégiques</p>
      </div>

    </div>

  </div>
</section>
<!-- TEMOIGNAGES -->
<section class="section testimonials-section">

  <div class="container">

    <!-- HEADER -->
    <div class="section-header" data-aos="fade-up">

      <span class="section-badge">
        TÉMOIGNAGES
      </span>

      <h2 class="section-title">
        Ce que disent nos clients
      </h2>

      <p class="section-subtitle">
        La satisfaction de nos clients et partenaires est au cœur
        de la vision du Groupe VIRAS.
      </p>

    </div>

    <!-- GRID -->
    <div class="testimonials-grid">

      <!-- Témoignages gérés depuis l'admin -->
      <template v-if="temoignages.length">
        <div
          v-for="(t, i) in temoignages"
          :key="t.id"
          class="testimonial-card"
          data-aos="fade-up"
          :data-aos-delay="(i % 3 + 1) * 100"
        >
          <div class="testimonial-top">
            <div class="testimonial-avatar">
              <img v-if="t.photo" :src="t.photo" :alt="t.nom" class="testimonial-photo" />
              <i v-else class="bi bi-person-circle"></i>
            </div>
            <div class="testimonial-rating" :aria-label="`${t.note} sur 5`">
              <i v-for="n in 5" :key="n" class="bi" :class="n <= t.note ? 'bi-star-fill' : 'bi-star'"></i>
            </div>
          </div>
          <p class="testimonial-text">{{ t.message }}</p>
          <div class="testimonial-client">
            <h4>{{ t.nom }}</h4>
            <span>{{ t.fonction || t.filiale }}</span>
          </div>
        </div>
      </template>

      <!-- Témoignages par défaut (tant qu'aucun n'est publié dans l'admin) -->
      <template v-else>

      <!-- CARD -->
      <div
        class="testimonial-card"
        data-aos="fade-up"
        data-aos-delay="100"
      >

        <div class="testimonial-top">

          <div class="testimonial-avatar">
            <i class="bi bi-person-circle"></i>
          </div>

          <div class="testimonial-rating">
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
          </div>

        </div>

        <p class="testimonial-text">
          Louga Voyages nous a offert une organisation parfaite
          pour notre voyage religieux avec un accompagnement
          exceptionnel du début à la fin.
        </p>

        <div class="testimonial-client">
          <h4>Client Louga Voyages</h4>
          <span>Voyage & Tourisme</span>
        </div>

      </div>

      <!-- CARD -->
      <div
        class="testimonial-card"
        data-aos="fade-up"
        data-aos-delay="200"
      >

        <div class="testimonial-top">

          <div class="testimonial-avatar">
            <i class="bi bi-building"></i>
          </div>

          <div class="testimonial-rating">
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
          </div>

        </div>

        <p class="testimonial-text">
          Saveurs N'Deco a rendu notre événement exceptionnel
          grâce à une gastronomie remarquable et une organisation
          très professionnelle.
        </p>

        <div class="testimonial-client">
          <h4>Entreprise partenaire</h4>
          <span>Événementiel</span>
        </div>

      </div>

      <!-- CARD -->
      <div
        class="testimonial-card"
        data-aos="fade-up"
        data-aos-delay="300"
      >

        <div class="testimonial-top">

          <div class="testimonial-avatar">
            <i class="bi bi-hospital"></i>
          </div>

          <div class="testimonial-rating">
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
            <i class="bi bi-star-fill"></i>
          </div>

        </div>

        <p class="testimonial-text">
          Lamien Consulting nous a aidés à structurer notre projet
          de santé publique avec efficacité et expertise stratégique.
        </p>

        <div class="testimonial-client">
          <h4>Institution publique</h4>
          <span>Santé & Consulting</span>
        </div>

      </div>

      </template>

    </div>

  </div>

</section>
<!-- PARTENAIRES -->
<section class="section partners-section">

  <div class="container">

    <!-- HEADER -->
    <div class="section-header" data-aos="fade-up">

      <span class="section-badge">
        NOS PARTENAIRES
      </span>

      <h2 class="section-title">
        Ils nous font confiance
      </h2>

      <p class="section-subtitle">
        Le Groupe VIRAS collabore avec des entreprises,
        institutions et organisations de référence
        au niveau national et international.
      </p>

    </div>

    <!-- GRID -->
    <div class="partners-grid">

      <!-- PARTNER -->
      <div
        class="partner-card"
        data-aos="zoom-in"
        data-aos-delay="100"
      >
        <div class="partner-icon">
          <i class="bi bi-globe2"></i>
        </div>

        <h3>Organisation internationale</h3>

        <p>
          Collaboration sur des projets stratégiques
          et programmes de développement.
        </p>
      </div>

      <!-- PARTNER -->
      <div
        class="partner-card"
        data-aos="zoom-in"
        data-aos-delay="200"
      >
        <div class="partner-icon">
          <i class="bi bi-buildings"></i>
        </div>

        <h3>Entreprise privée</h3>

        <p>
          Accompagnement des entreprises avec des solutions
          innovantes et multisectorielles.
        </p>
      </div>

      <!-- PARTNER -->
      <div
        class="partner-card"
        data-aos="zoom-in"
        data-aos-delay="300"
      >
        <div class="partner-icon">
          <i class="bi bi-bank"></i>
        </div>

        <h3>Institution publique</h3>

        <p>
          Partenariats dans les domaines de la santé,
          formation et développement.
        </p>
      </div>

      <!-- PARTNER -->
      <div
        class="partner-card"
        data-aos="zoom-in"
        data-aos-delay="400"
      >
        <div class="partner-icon">
          <i class="bi bi-stars"></i>
        </div>

        <h3>Partenaire stratégique</h3>

        <p>
          Relations durables fondées sur la confiance,
          la performance et l’innovation.
        </p>
      </div>

    </div>

  </div>

</section>

  <!-- DERNIÈRES ACTUALITÉS (gérées depuis l'admin) -->
<section v-if="dernieres.length" class="section news-section">
  <div class="container">
    <div class="news-head" data-aos="fade-up">
      <div>
        <span class="section-badge">ACTUALITÉS</span>
        <h2 class="section-title">Les dernières nouvelles du Groupe</h2>
      </div>
      <router-link to="/actualites" class="news-all">
        Toutes les actualités <i class="bi bi-arrow-right"></i>
      </router-link>
    </div>
    <div class="news-grid">
      <publication-card
        v-for="(pub, i) in dernieres"
        :key="pub.id"
        :pub="pub"
        data-aos="fade-up"
        :data-aos-delay="i * 120"
      />
    </div>
  </div>
</section>

  <!-- CONTACT -->
<section class="contact-section">

  <div
    class="container"
    data-aos="zoom-in"
    :style="{ transform: `translateY(${scrollOffset*0.01}px)` }"
  >

    <div class="contact-card">

      <!-- LEFT -->
      <div class="contact-content">

        <span class="section-badge">
          CONTACT & COLLABORATION
        </span>

        <h2 class="contact-title">
          Construisons ensemble vos projets
        </h2>

        <p class="contact-text">
          Vous souhaitez collaborer avec le Groupe VIRAS,
          obtenir des informations sur nos services
          ou développer un partenariat stratégique ?
          Notre équipe reste à votre écoute.
        </p>

        <!-- FEATURES -->
        <div class="contact-features">

          <div class="contact-feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Accompagnement professionnel</span>
          </div>

          <div class="contact-feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Réponse rapide et efficace</span>
          </div>

          <div class="contact-feature">
            <i class="bi bi-check-circle-fill"></i>
            <span>Solutions adaptées à vos besoins</span>
          </div>

        </div>

        <!-- BUTTONS -->
        <div class="contact-actions">

          <RouterLink
            to="/contact"
            class="contact-btn primary-btn"
          >
            <i class="bi bi-send-fill"></i>
            Nous contacter
          </RouterLink>

          <a
            href="tel:+22300000000"
            class="contact-btn secondary-btn"
          >
            <i class="bi bi-telephone-fill"></i>
            Appeler
          </a>

        </div>

      </div>

      <!-- RIGHT -->
      <div class="contact-visual">

        <div class="contact-icon-box">
          <i class="bi bi-headset"></i>
        </div>

        <div class="contact-floating-card card-one">
          <i class="bi bi-envelope-fill"></i>
          <span>Support réactif</span>
        </div>

        <div class="contact-floating-card card-two">
          <i class="bi bi-globe2"></i>
          <span>Vision internationale</span>
        </div>

      </div>

    </div>

  </div>

</section>

  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, reactive } from 'vue'
import PublicationCard from '@/components/PublicationCard.vue'
import { getAccueil } from '@/services/api'
import { appliquerParametres, rafraichirAnimations } from '@/composables/useSite'
//import CardView from "../components/CardView.vue"
import hero1 from '@/assets/silhouette-man-mountain.jpg'
//import hero2 from '@/assets/logo_groupeviras.jpeg'
//import hero3 from '@/assets/logo_groupeviras.jpeg'
import lougaLogo from "@/assets/louga_logo.jpg"
import saveursLogo from "@/assets/nsaveur_deco.png"
import lamienLogo from "@/assets/groupe_img/lamien_consulting.jpeg"
import cliniqueLogo from "@/assets/logo_demassi.jpeg"
import BoutiqueLogo from "@/assets/logo_baraka.jpeg"
import PoolLogo from '@/assets/groupe_img/pole_formation.jpeg'
import CentreAlmanassikLogo from '@/assets/groupe_img/centre_almanassik.jpeg'
import hero4 from '@/assets/ramadan-mali-white-background.jpg'
import hero5 from '@/assets/side-view-chicken-kebab-lavash-served-with-fresh-herbs-onion-adjika-sauce.jpg'
import hero6 from '@/assets/asian-food-restaurant.jpg'
import maisonVirasLogo from '@/assets/log_maison_vi.jpeg'
import virasTechLogo from '@/assets/logo_tech.png'
import logoGroupe from '@/assets/logo_groupeviras.jpeg'

// Images par défaut du diaporama ; remplacées par celles de l'admin (Diaporama d'accueil) si elles existent
const slidesParDefaut = [hero4,hero1,hero6,hero5]

// ===== Contenu dynamique (admin) =====
const accueil = ref(null)
const aLaUne = computed(() => accueil.value?.aLaUne || null)
const dernieres = computed(() => accueil.value?.dernieresPublications || [])
const temoignages = computed(() => accueil.value?.temoignages || [])
const iconeALaUne = computed(() => ({
  recrutement: 'bi-megaphone-fill',
  evenement: 'bi-calendar-event',
  promotion: 'bi-tag-fill',
  communique: 'bi-file-earmark-text'
}[aLaUne.value?.categorie] || 'bi-stars'))
const slides = computed(() => {
  const images = (accueil.value?.bannieres || []).map(b => b.image).filter(Boolean)
  return images.length ? images : slidesParDefaut
})

onMounted(async () => {
  try {
    accueil.value = await getAccueil()
    appliquerParametres(accueil.value.parametres)
    rafraichirAnimations()
    if (currentSlide.value >= slides.value.length) currentSlide.value = 0
  } catch (e) {
    accueil.value = null // le site garde son contenu par défaut
  }
})

const currentSlide = ref(0)
let sliderInterval = null
onMounted(()=>{sliderInterval=setInterval(nextSlide,5000)})
onBeforeUnmount(()=>clearInterval(sliderInterval))
function nextSlide(){currentSlide.value=(currentSlide.value+1)%slides.value.length}
function prevSlide(){currentSlide.value=(currentSlide.value-1+slides.value.length)%slides.value.length}

const title = "Groupe VIRAS"
const titleLetters = title.split("")

const filialesParDefaut = [

{
  title: "Louga Voyages",
  description:
  "Agence spécialisée dans l’organisation de voyages, tourisme international, billetterie, Omra et services de mobilité.",
  logo: lougaLogo,
  icon: "bi bi-airplane-engines",
  route: "/filiales/louga-voyages"
},

{
  title: "Saveurs N'Deco",
  description:
  "Restaurant gastronomique et organisation d’événements culinaires offrant des expériences uniques et haut de gamme.",
  logo: saveursLogo,
  icon: "bi bi-cup-hot",
  route: "/filiales/saveur-deco"
},

{
  title: "Lamien Consulting",
  description:
  "Cabinet de conseil spécialisé en santé publique, management hospitalier et accompagnement stratégique.",
  logo: lamienLogo,
  icon: "bi bi-briefcase",
  route: "/filiales/lamien-consulting"
},

{
  title: "Clinique Médicale DemAssi",
  description:
  "Structure médicale moderne offrant des soins de qualité et des services de santé spécialisés.",
  logo: cliniqueLogo,
  icon: "bi bi-hospital",
  route: "/filiales/clinique-demassi"
},

{
  title: "Boutique Baraka",
  description:
  "Boutique spécialisée dans la vente de produits, accessoires et articles sélectionnés avec qualité et confiance.",
  logo: BoutiqueLogo,
  icon: "bi bi-bag-heart",
  route: "/filiales/baraka-boutique"
},

{
  title: "Pool Formation",
  description:
  "Centre de formation professionnelle proposant des programmes adaptés aux besoins du marché et des entreprises.",
  logo: PoolLogo,
  icon: "bi bi-mortarboard",
  route: "/filiales/pool-formation"
},

{
  title: "Centre Al-manassik",
  description:
  "Centre dédié à l’accompagnement et à la formation des pèlerins pour le Hajj et la Omra.",
  logo: CentreAlmanassikLogo,
  icon: "bi bi-moon-stars",
  route: "/filiales/centre-almanassik"
},
{
  title: "Maison VIRAS",
  description:
    "Maison de luxe inspirée de l’Afrique et du raffinement international, spécialisée dans le prêt-à-porter haut de gamme, la couture, la maroquinerie et les accessoires de prestige.",
  logo: maisonVirasLogo, // à importer comme les autres logos
  icon: "bi bi-gem",
  route: "/filiales/maison-viras"
},
{
  title: "VIRAS Technologies",
  description:
    "Développement de solutions numériques innovantes : applications de gestion, plateformes web, applications mobiles, digitalisation des entreprises et accompagnement technologique.",
  logo: virasTechLogo,
  icon: "bi bi-cpu-fill",
  route: "/filiales/viras-technologies"
},
]

// Les filiales affichées : textes et logos de l'admin s'ils sont renseignés,
// sinon ceux ci-dessus. Les nouvelles filiales créées dans l'admin s'ajoutent à la fin.
const filiales = computed(() => {
  const api = accueil.value?.filiales || []
  const parSlug = Object.fromEntries(api.map(f => [f.slug, f]))
  const liste = filialesParDefaut.map(f => {
    const a = parSlug[f.route.split('/').pop()]
    return a ? { ...f, title: a.nom || f.title, description: a.accroche || f.description, logo: a.logo || f.logo } : f
  })
  const connus = new Set(filialesParDefaut.map(f => f.route.split('/').pop()))
  api.filter(f => !connus.has(f.slug)).forEach(f => liste.push({
    title: f.nom,
    description: f.accroche || '',
    logo: f.logo || logoGroupe,
    icon: 'bi bi-building',
    route: `/filiales/${f.slug}`
  }))
  return liste
})

const expertise = [

{
  icon: "bi bi-airplane-engines",
  title: "Tourisme & Voyage"
},

{
  icon: "bi bi-cup-hot",
  title: "Gastronomie & Événements"
},

{
  icon: "bi bi-hospital",
  title: "Santé & Consulting"
},

{
  icon: "bi bi-truck",
  title: "Transport & Logistique"
},

{
  icon: "bi bi-mortarboard",
  title: "Formation & Expertise"
},

{
  icon: "bi bi-briefcase",
  title: "Conseil stratégique"
}

]

const slider = ref(null)
// eslint-disable-next-line no-unused-vars
function slideNext(){slider.value.scrollBy({left:280,behavior:'smooth'})}
// eslint-disable-next-line no-unused-vars
function slidePrev(){slider.value.scrollBy({left:-280,behavior:'smooth'})}

const parallax = reactive({x:0,y:0})
function handleMouseMove(e){
  const centerX = window.innerWidth/2
  const centerY = window.innerHeight/2
  parallax.x=(e.clientX-centerX)/30
  parallax.y=(e.clientY-centerY)/30
}

// Scroll parallax
const scrollOffset = ref(0)
function handleScroll(){ scrollOffset.value = window.scrollY }
window.addEventListener('scroll', handleScroll)
onBeforeUnmount(()=>window.removeEventListener('scroll', handleScroll))
</script>

<style scoped>
/* =========================
   DERNIÈRES ACTUALITÉS
========================= */
.news-section{
  padding:100px 0;
  background:#fff;
}
.news-head{
  display:flex;
  justify-content:space-between;
  align-items:flex-end;
  gap:20px;
  flex-wrap:wrap;
  margin-bottom:40px;
}
.news-head .section-title{
  margin-bottom:0;
}
.news-all{
  font-weight:700;
  color:#0F2B45;
  border-bottom:2px solid #F0C95C;
  padding-bottom:2px;
}
.news-grid{
  display:grid;
  grid-template-columns:repeat(auto-fill,minmax(300px,1fr));
  gap:28px;
}
.testimonial-photo{
  width:100%;
  height:100%;
  object-fit:cover;
  border-radius:inherit;
}
@media(max-width:768px){
  .news-section{ padding:70px 0; }
  .news-grid{ grid-template-columns:1fr; }
}

/* =========================
   HERO SECTION
========================= */

.hero-section{
  position:relative;
  min-height:100vh;
  overflow:hidden;

  display:flex;
  align-items:center;
  justify-content:center;

  background:#0F2B45;
}

/* SLIDER */

.hero-slider{
  position:absolute;
  inset:0;
}

.hero-slide{
  position:absolute;
  inset:0;

  background-size:cover;
  background-position:center;

  opacity:0;

  transition:
    opacity 1.2s ease,
    transform 0.5s ease;

  transform:scale(1.05);
}

.hero-slide.active{
  opacity:1;
}

/* OVERLAY */

.hero-overlay{
  position:absolute;
  inset:0;

  background:
    linear-gradient(
      135deg,
      rgba(5,15,25,0.88),
      rgba(15,43,69,0.72)
    );

  z-index:2;
}

/* GOLD LIGHT */

.hero-light{
  position:absolute;

  width:600px;
  height:600px;

  border-radius:50%;

  background:
    radial-gradient(
      rgba(240,201,92,0.15),
      transparent 70%
    );

  top:-150px;
  right:-120px;

  z-index:2;
}

/* CONTAINER */

.hero-container{
  position:relative;
  z-index:5;
}

/* CONTENT */

.hero-content{
  max-width:850px;
  text-align:center;
  margin:auto;
}

/* BADGE */

.hero-badge{
  display:inline-flex;
  align-items:center;
  gap:10px;

  padding:12px 22px;

  border-radius:50px;

  background:
    rgba(255,255,255,0.08);

  border:1px solid rgba(255,255,255,0.1);

  backdrop-filter:blur(10px);

  color:#F0C95C;
  font-weight:600;

  margin-bottom:30px;
}

.hero-badge i{
  font-size:1rem;
}

/* LOGO */

.hero-logo-wrapper{
  margin-bottom:30px;
}

.hero-logo{
  width:170px;
  height:170px;

  object-fit:cover;

  border-radius:50%;

  border:5px solid #F0C95C;

  box-shadow:
    0 20px 50px rgba(240,201,92,0.3);

  animation:heroFloat 4s ease-in-out infinite;
}

@keyframes heroFloat{

  0%{
    transform:translateY(0px);
  }

  50%{
    transform:translateY(-15px);
  }

  100%{
    transform:translateY(0px);
  }

}

/* TITLE */

.hero-title{
  font-size:5rem;
  font-weight:900;
  line-height:1.1;

  margin-bottom:25px;

  color:white;
}

.hero-title span{
  display:inline-block;
  opacity:0;

  animation:
    heroLetter 0.5s forwards;
}

@keyframes heroLetter{

  from{
    opacity:0;
    transform:translateY(-20px);
  }

  to{
    opacity:1;
    transform:translateY(0);
  }

}

/* SUBTITLE */

.hero-subtitle{
  font-size:1.3rem;
  line-height:2;

  color:#d1d5db;

  margin-bottom:45px;
}

/* ACTIONS */

.hero-actions{
  display:flex;
  justify-content:center;
  gap:20px;
  flex-wrap:wrap;

  margin-bottom:60px;
}

/* BUTTON */

.hero-btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  gap:12px;

  padding:16px 34px;

  border-radius:50px;

  font-weight:700;
  text-decoration:none;

  transition:0.4s;
}

/* PRIMARY */

.primary-btn{
  background:
    linear-gradient(
      90deg,
      #F0C95C,
      #FFD166
    );

  color:#0F2B45;
}

.primary-btn:hover{
  transform:translateY(-4px);

  box-shadow:
    0 15px 35px rgba(240,201,92,0.35);
}

/* SECONDARY */

.secondary-btn{
  background:
    rgba(255,255,255,0.08);

  border:1px solid rgba(255,255,255,0.1);

  color:white;

  backdrop-filter:blur(10px);
}

.secondary-btn:hover{
  background:white;
  color:#0F2B45;
}

/* STATS */

.hero-stats{
  display:flex;
  justify-content:center;
  gap:60px;
  flex-wrap:wrap;
}

.hero-stat h3{
  font-size:2.3rem;
  color:#F0C95C;
  font-weight:800;
  margin-bottom:5px;
}

.hero-stat span{
  color:#d1d5db;
}

/* SCROLL */

.hero-scroll{
  position:absolute;

  bottom:30px;
  left:50%;

  transform:translateX(-50%);

  z-index:5;
}

.hero-scroll span{
  display:block;

  width:30px;
  height:50px;

  border:2px solid rgba(255,255,255,0.5);
  border-radius:20px;

  position:relative;
}

.hero-scroll span::before{
  content:"";

  position:absolute;

  width:6px;
  height:10px;

  border-radius:50%;

  background:#F0C95C;

  left:50%;
  top:10px;

  transform:translateX(-50%);

  animation:scrollAnim 1.5s infinite;
}

@keyframes scrollAnim{

  0%{
    opacity:0;
    top:10px;
  }

  50%{
    opacity:1;
  }

  100%{
    opacity:0;
    top:25px;
  }

}

/* CONTROLS */

.hero-controls{
  position:absolute;

  width:100%;
  top:50%;

  transform:translateY(-50%);

  display:flex;
  justify-content:space-between;

  padding:0 30px;

  z-index:6;
}

.hero-controls button{
  width:60px;
  height:60px;

  border:none;
  border-radius:50%;

  cursor:pointer;

  background:
    rgba(255,255,255,0.08);

  backdrop-filter:blur(10px);

  border:1px solid rgba(255,255,255,0.1);

  color:white;
  font-size:1.4rem;

  transition:0.4s;
}

.hero-controls button:hover{
  background:#F0C95C;
  color:#0F2B45;

  transform:scale(1.08);
}

/* RESPONSIVE */

@media(max-width:992px){

  .hero-title{
    font-size:3.5rem;
  }

}

@media(max-width:768px){

  .hero-section{
    min-height:95vh;
    padding:100px 0;
  }

  .hero-title{
    font-size:2.5rem;
  }

  .hero-subtitle{
    font-size:1rem;
    line-height:1.8;
  }

  .hero-logo{
    width:130px;
    height:130px;
  }

  .hero-actions{
    flex-direction:column;
  }

  .hero-btn{
    width:100%;
  }

  .hero-controls{
    padding:0 10px;
  }

  .hero-controls button{
    width:45px;
    height:45px;
  }

  .hero-stats{
    gap:30px;
  }

}

/* FILIALES SLIDER */
.filiales-slider{position:relative;display:flex;align-items:center;}
.slides-container{display:flex;overflow-x:auto;scroll-behavior:smooth;gap:20px;padding:10px 0;}
.slides-container::-webkit-scrollbar{display:none;}
.hover-3d{transition: transform 0.3s ease;transform-style: preserve-3d;}
.hover-3d:hover{transform: rotateY(8deg) rotateX(4deg) scale(1.05);}

/* SECTION */
.filiales-section{
padding:100px 0;
background:linear-gradient(180deg,#f8fafc,#ffffff);
}

.section-subtitle{
text-align:center;
color:#6b7280;
margin-bottom:60px;
font-size:1.1rem;
}

/* GRID */
.filiales-grid{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
gap:35px;
}

/* CARD */
.filiale-card{
position:relative;
border-radius:20px;
overflow:hidden;
background:white;
box-shadow:0 10px 35px rgba(0,0,0,0.08);
transition:all 0.4s ease;
cursor:pointer;
}

.filiale-card:hover{
transform:translateY(-10px) scale(1.03);
box-shadow:0 20px 45px rgba(0,0,0,0.15);
}

/* BACKGROUND EFFECT */
.filiale-bg{
position:absolute;
inset:0;
background:linear-gradient(135deg,#0F2B45,#1e4b6d);
opacity:0;
transition:0.4s;
}

.filiale-card:hover .filiale-bg{
opacity:0.9;
}

/* CONTENT */
.filiale-content{
position:relative;
padding:40px 25px;
text-align:center;
z-index:2;
transition:0.4s;
}

.filiale-card:hover .filiale-content{
color:white;
}

/* LOGO */
.filiale-logo img{
width:70px;
height:70px;
object-fit:cover;
border-radius:50%;
margin-bottom:15px;
border:3px solid #F0C95C;
}

/* ICON */
.filiale-icon{
  width:80px;
  height:80px;
  margin:0 auto 20px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:50%;
  background:rgba(240,201,92,0.15);
  border:1px solid rgba(240,201,92,0.3);
  transition:0.4s;
}

.filiale-icon i{
  font-size:2rem;
  color:#F0C95C;
  transition:0.4s;
}

.filiale-card:hover .filiale-icon{
  background:#F0C95C;
  transform:rotate(8deg) scale(1.08);
}

.filiale-card:hover .filiale-icon i{
  color:#0F2B45;
}

/* TITLE */
.filiale-title{
font-size:1.3rem;
font-weight:700;
margin-bottom:10px;
}

/* DESCRIPTION */
.filiale-description{
font-size:0.95rem;
line-height:1.5;
opacity:0.9;
margin-bottom:20px;
}

/* BUTTON */
.filiale-btn{
border:none;
background:#F0C95C;
color:#0F2B45;
padding:10px 20px;
border-radius:30px;
font-weight:600;
transition:0.3s;
}

.filiale-btn:hover{
background:#FFD166;
transform:scale(1.05);
}

/* HOVER TEXT COLOR */
.filiale-card:hover .filiale-description{
color:#e5e7eb;
}

/* =========================
   ABOUT SECTION
========================= */

.about-section{
  position:relative;
  padding:120px 0;
  overflow:hidden;
  background:#f8fafc;
}

/* SHAPES */

.about-shape{
  position:absolute;
  border-radius:50%;
  filter:blur(90px);
  z-index:1;
}

.shape-1{
  width:350px;
  height:350px;
  background:rgba(240,201,92,0.15);
  top:-80px;
  left:-80px;
}

.shape-2{
  width:300px;
  height:300px;
  background:rgba(15,43,69,0.08);
  bottom:-80px;
  right:-80px;
}

/* CONTAINER */

.about-container{
  position:relative;
  z-index:2;

  display:grid;
  grid-template-columns:1fr 1fr;
  gap:80px;
  align-items:center;
}

/* =========================
   VISUAL
========================= */

.about-visual{
  position:relative;
}

/* MAIN IMAGE */

.about-main-image{
  position:relative;
}

.about-main-image img{
  width:100%;
  border-radius:30px;

  box-shadow:
    0 25px 50px rgba(0,0,0,0.15);

  transition:0.5s;
}

.about-main-image img:hover{
  transform:scale(1.03);
}

/* FLOATING CARD */

.about-floating-card{
  position:absolute;

  bottom:30px;
  left:-30px;

  display:flex;
  align-items:center;
  gap:15px;

  background:white;
  padding:18px 22px;

  border-radius:20px;

  box-shadow:
    0 15px 35px rgba(0,0,0,0.12);

  animation:floatCard 4s ease-in-out infinite;
}

@keyframes floatCard{

  0%{
    transform:translateY(0px);
  }

  50%{
    transform:translateY(-10px);
  }

  100%{
    transform:translateY(0px);
  }

}

.floating-icon{
  width:55px;
  height:55px;

  display:flex;
  align-items:center;
  justify-content:center;

  border-radius:15px;

  background:
    linear-gradient(
      135deg,
      #F0C95C,
      #FFD166
    );

  color:#0F2B45;
  font-size:1.4rem;
}

.about-floating-card h4{
  margin:0;
  font-size:1rem;
  color:#0F2B45;
}

.about-floating-card p{
  margin:0;
  color:#6b7280;
  font-size:0.9rem;
}

/* MINI GALLERY */

.about-mini-gallery{
  display:flex;
  gap:15px;

  margin-top:20px;
}

.mini-card{
  flex:1;
  overflow:hidden;
  border-radius:20px;
}

.mini-card img{
  width:100%;
  height:120px;
  object-fit:cover;

  transition:0.4s;
}

.mini-card img:hover{
  transform:scale(1.08);
}

/* =========================
   CONTENT
========================= */

.about-content{
  position:relative;
}

/* BADGE */

.about-badge{
  display:inline-flex;
  align-items:center;
  gap:10px;

  background:
    rgba(240,201,92,0.12);

  color:#F0C95C;

  padding:12px 22px;

  border-radius:50px;

  font-weight:700;
  font-size:0.85rem;

  margin-bottom:25px;
}

/* TITLE */

.about-title{
  font-size:3rem;
  font-weight:900;
  line-height:1.2;

  color:#0F2B45;

  margin-bottom:25px;
}

.about-title span{
  color:#F0C95C;
}

/* DESCRIPTION */

.about-description{
  font-size:1.05rem;
  line-height:2;
  color:#4b5563;

  margin-bottom:20px;
}

/* FEATURES */

.about-features{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:20px;

  margin-top:40px;
}

/* FEATURE CARD */

.feature-card{
  display:flex;
  gap:15px;

  background:white;
  padding:20px;

  border-radius:20px;

  box-shadow:
    0 10px 25px rgba(0,0,0,0.06);

  transition:0.4s;
}

.feature-card:hover{
  transform:translateY(-5px);

  box-shadow:
    0 18px 35px rgba(0,0,0,0.1);
}

.feature-icon{
  width:55px;
  height:55px;

  display:flex;
  align-items:center;
  justify-content:center;

  border-radius:15px;

  background:
    linear-gradient(
      135deg,
      #0F2B45,
      #1f4d73
    );

  color:#F0C95C;
  font-size:1.3rem;

  flex-shrink:0;
}

.feature-card h4{
  margin:0 0 6px;
  color:#0F2B45;
}

.feature-card p{
  margin:0;
  font-size:0.92rem;
  color:#6b7280;
  line-height:1.6;
}

/* BUTTONS */

.about-actions{
  display:flex;
  gap:20px;
  flex-wrap:wrap;

  margin-top:45px;
}

.about-btn{
  display:inline-flex;
  align-items:center;
  gap:12px;

  padding:15px 30px;

  border-radius:50px;

  text-decoration:none;
  font-weight:700;

  transition:0.4s;
}

/* PRIMARY */

.primary-btn{
  background:
    linear-gradient(
      90deg,
      #F0C95C,
      #FFD166
    );

  color:#0F2B45;
}

.primary-btn:hover{
  transform:translateY(-4px);

  box-shadow:
    0 15px 35px rgba(240,201,92,0.35);
}

/* SECONDARY */

.secondary-btn{
  background:#0F2B45;
  color:white;
}

.secondary-btn:hover{
  background:#163a5c;

  transform:translateY(-4px);
}

/* =========================
   RESPONSIVE
========================= */

@media(max-width:992px){

  .about-container{
    grid-template-columns:1fr;
  }

}

@media(max-width:768px){

  .about-section{
    padding:90px 0;
  }

  .about-title{
    font-size:2.2rem;
    text-align:center;
  }

  .about-content{
    text-align:center;
  }

  .about-badge{
    margin:auto auto 25px;
  }

  .about-features{
    grid-template-columns:1fr;
  }

  .about-actions{
    justify-content:center;
  }

  .about-floating-card{
    position:relative;
    left:0;
    bottom:0;
    margin-top:20px;
  }

  .about-mini-gallery{
    flex-direction:column;
  }

  .mini-card img{
    height:160px;
  }

}

/* =========================
   EXPERTISE SECTION
========================= */

.expertise-grid{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
  gap:35px;
  margin-top:60px;
}

/* CARD */

.expertise-CardView{
  position:relative;
  overflow:hidden;
  background:white;
  border-radius:28px;
  padding:45px 30px;
  text-align:center;
  transition:0.5s ease;
  box-shadow:0 15px 40px rgba(0,0,0,0.08);
  border:1px solid rgba(15,43,69,0.05);
}

/* GOLD EFFECT */

.expertise-CardView::before{
  content:"";
  position:absolute;
  inset:0;
  background:
    linear-gradient(
      135deg,
      rgba(240,201,92,0.12),
      transparent
    );
  opacity:0;
  transition:0.5s;
}

.expertise-CardView:hover::before{
  opacity:1;
}

/* HOVER */

.expertise-CardView:hover{
  transform:translateY(-12px);
  box-shadow:0 25px 55px rgba(0,0,0,0.15);
}

/* ICON */

.expert-icon{
  width:95px;
  height:95px;
  margin:0 auto 25px;
  border-radius:50%;
  display:flex;
  align-items:center;
  justify-content:center;
  background:rgba(240,201,92,0.15);
  border:1px solid rgba(240,201,92,0.3);
  transition:0.5s;
}

.expert-icon i{
  font-size:2.5rem;
  color:#F0C95C;
  transition:0.5s;
}

/* ICON HOVER */

.expertise-CardView:hover .expert-icon{
  background:#F0C95C;
  transform:rotate(8deg) scale(1.08);
}

.expertise-CardView:hover .expert-icon i{
  color:#0F2B45;
}

/* TITLE */

.expert-title{
  font-size:1.25rem;
  font-weight:800;
  color:#0F2B45;
  line-height:1.5;
}

/* RESPONSIVE */

@media(max-width:768px){

  .expertise-grid{
    gap:25px;
  }

  .expertise-CardView{
    padding:35px 25px;
  }

  .expert-icon{
    width:80px;
    height:80px;
  }

  .expert-icon i{
    font-size:2rem;
  }

  .expert-title{
    font-size:1.1rem;
  }

}

/* =========================
   CONTACT SECTION
========================= */

.contact-section{
  position:relative;
  overflow:hidden;
  padding:120px 0;

  background:
    linear-gradient(
      135deg,
      #0F2B45 0%,
      #163a57 50%,
      #1f4b6b 100%
    );
}

/* CARD */

.contact-card{
  position:relative;

  display:grid;
  grid-template-columns:1.2fr 0.8fr;
  gap:60px;

  align-items:center;

  padding:70px;

  border-radius:35px;

  overflow:hidden;

  background:
    rgba(255,255,255,0.08);

  backdrop-filter:blur(12px);

  border:1px solid rgba(255,255,255,0.08);

  box-shadow:
    0 25px 60px rgba(0,0,0,0.25);
}

/* LIGHT EFFECT */

.contact-card::before{
  content:"";
  position:absolute;
  width:450px;
  height:450px;
  border-radius:50%;

  background:
    rgba(240,201,92,0.08);

  top:-180px;
  right:-120px;
}

/* CONTENT */

.contact-content{
  position:relative;
  z-index:2;
}

.contact-title{
  font-size:3rem;
  line-height:1.2;
  font-weight:800;
  color:white;
  margin:20px 0;
}

.contact-text{
  color:#d1d5db;
  line-height:1.9;
  font-size:1.05rem;
  margin-bottom:35px;
}

/* FEATURES */

.contact-features{
  display:flex;
  flex-direction:column;
  gap:18px;
  margin-bottom:40px;
}

.contact-feature{
  display:flex;
  align-items:center;
  gap:12px;

  color:white;
  font-weight:500;
}

.contact-feature i{
  color:#F0C95C;
  font-size:1.1rem;
}

/* BUTTONS */

.contact-actions{
  display:flex;
  gap:20px;
  flex-wrap:wrap;
}

.contact-btn{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  gap:12px;

  padding:15px 30px;
  border-radius:50px;

  font-weight:700;
  text-decoration:none;

  transition:0.4s;
}

/* PRIMARY */

.primary-btn{
  background:
    linear-gradient(
      90deg,
      #F0C95C,
      #FFD166
    );

  color:#0F2B45;
}

.primary-btn:hover{
  transform:translateY(-4px);
  box-shadow:
    0 12px 30px rgba(240,201,92,0.4);
}

/* SECONDARY */

.secondary-btn{
  border:1px solid rgba(255,255,255,0.2);
  color:white;
  background:rgba(255,255,255,0.05);
}

.secondary-btn:hover{
  background:white;
  color:#0F2B45;
}

/* RIGHT VISUAL */

.contact-visual{
  position:relative;
  height:100%;
  min-height:400px;

  display:flex;
  align-items:center;
  justify-content:center;
}

/* MAIN ICON */

.contact-icon-box{
  width:220px;
  height:220px;

  border-radius:50%;

  display:flex;
  align-items:center;
  justify-content:center;

  background:
    linear-gradient(
      135deg,
      #F0C95C,
      #FFD166
    );

  color:#0F2B45;
  font-size:5rem;

  box-shadow:
    0 20px 50px rgba(240,201,92,0.35);

  animation:floatIcon 4s ease-in-out infinite;
}

@keyframes floatIcon{
  0%{
    transform:translateY(0px);
  }

  50%{
    transform:translateY(-15px);
  }

  100%{
    transform:translateY(0px);
  }
}

/* FLOATING CARDS */

.contact-floating-card{
  position:absolute;

  display:flex;
  align-items:center;
  gap:10px;

  padding:16px 22px;

  border-radius:18px;

  background:
    rgba(255,255,255,0.08);

  backdrop-filter:blur(10px);

  border:1px solid rgba(255,255,255,0.1);

  color:white;

  box-shadow:
    0 10px 25px rgba(0,0,0,0.15);
}

.contact-floating-card i{
  color:#F0C95C;
}

.card-one{
  top:30px;
  right:0;
}

.card-two{
  bottom:40px;
  left:0;
}

/* RESPONSIVE */

@media(max-width:992px){

  .contact-card{
    grid-template-columns:1fr;
    padding:50px 35px;
    gap:40px;
  }

  .contact-title{
    font-size:2.2rem;
  }

  .contact-visual{
    min-height:280px;
  }

}

@media(max-width:768px){

  .contact-section{
    padding:80px 0;
  }

  .contact-title{
    font-size:2rem;
  }

  .contact-actions{
    flex-direction:column;
  }

  .contact-btn{
    width:100%;
  }

  .contact-icon-box{
    width:170px;
    height:170px;
    font-size:4rem;
  }

  .contact-floating-card{
    position:relative;
    margin-top:15px;
  }

  .card-one,
  .card-two{
    top:auto;
    right:auto;
    left:auto;
    bottom:auto;
  }

}
/* Responsive */
@media(max-width:768px){
  .hero-title{font-size:2rem;}
  .hero-subtitle{font-size:1rem;}
  .about-grid{grid-template-columns:1fr;}
  .grid,.grid-3{grid-template-columns:1fr;}
  .btn-primary{padding:12px 30px;}
}

/* WHY SECTION */

.why-section{
  position:relative;
  overflow:hidden;
  padding:100px 0;
  background:
    linear-gradient(
      180deg,
      #f8fafc 0%,
      #ffffff 100%
    );
}

/* HEADER */

.section-header{
  text-align:center;
  max-width:800px;
  margin:auto;
  margin-bottom:70px;
}

/* GRID */

.why-grid{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(280px,1fr));
  gap:30px;
}

/* CARD */

.why-card{
  position:relative;
  background:white;
  padding:40px 30px;
  border-radius:24px;
  overflow:hidden;
  box-shadow:0 12px 35px rgba(0,0,0,0.07);
  transition:all 0.4s ease;
  border:1px solid rgba(15,43,69,0.05);
}

.why-card::before{
  content:"";
  position:absolute;
  inset:0;
  background:
    linear-gradient(
      135deg,
      rgba(15,43,69,0.03),
      rgba(240,201,92,0.08)
    );
  opacity:0;
  transition:0.4s;
}

.why-card:hover{
  transform:translateY(-12px);
  box-shadow:0 20px 45px rgba(0,0,0,0.12);
}

.why-card:hover::before{
  opacity:1;
}

/* ICON */

.why-icon{
  width:75px;
  height:75px;
  display:flex;
  align-items:center;
  justify-content:center;
  border-radius:20px;
  margin-bottom:25px;

  background:
    linear-gradient(
      135deg,
      #0F2B45,
      #1f4b6b
    );

  color:#F0C95C;
  font-size:2rem;

  box-shadow:
    0 10px 25px rgba(15,43,69,0.2);

  transition:0.4s;
}

.why-card:hover .why-icon{
  transform:scale(1.08) rotate(-5deg);
}

/* TITLE */

.why-card h3{
  font-size:1.35rem;
  font-weight:700;
  color:#0F2B45;
  margin-bottom:15px;
}

/* TEXT */

.why-card p{
  color:#6b7280;
  line-height:1.8;
  font-size:1rem;
}

/* RESPONSIVE */

@media(max-width:768px){

  .why-section{
    padding:80px 0;
  }

  .why-grid{
    grid-template-columns:1fr;
  }

  .why-card{
    padding:35px 25px;
  }

}


/* STATS */

.stats-section{
background:#0F2B45;
color:white;
text-align:center;
}

.stats-grid{
display:grid;
grid-template-columns:repeat(auto-fit,minmax(200px,1fr));
gap:40px;
}

.stat h3{
font-size:3rem;
color:#F0C95C;
}


/* =========================
   TESTIMONIALS SECTION
========================= */

.testimonials-section{
  position:relative;
  padding:110px 0;
  overflow:hidden;

  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #f8fafc 100%
    );
}

/* GRID */

.testimonials-grid{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(320px,1fr));
  gap:35px;
}

/* CARD */

.testimonial-card{
  position:relative;
  background:white;
  padding:40px 35px;
  border-radius:28px;
  overflow:hidden;

  border:1px solid rgba(15,43,69,0.05);

  box-shadow:
    0 15px 40px rgba(0,0,0,0.06);

  transition:0.5s ease;
}

/* HOVER */

.testimonial-card:hover{
  transform:translateY(-10px);

  box-shadow:
    0 25px 50px rgba(0,0,0,0.12);
}

/* GOLD EFFECT */

.testimonial-card::before{
  content:"";
  position:absolute;
  inset:0;

  background:
    linear-gradient(
      135deg,
      rgba(240,201,92,0.08),
      transparent
    );

  opacity:0;
  transition:0.5s;
}

.testimonial-card:hover::before{
  opacity:1;
}

/* TOP */

.testimonial-top{
  display:flex;
  align-items:center;
  justify-content:space-between;
  margin-bottom:25px;
}

/* AVATAR */

.testimonial-avatar{
  width:75px;
  height:75px;

  display:flex;
  align-items:center;
  justify-content:center;

  border-radius:22px;

  background:
    linear-gradient(
      135deg,
      #0F2B45,
      #1f4b6b
    );

  color:#F0C95C;
  font-size:2rem;

  box-shadow:
    0 10px 25px rgba(15,43,69,0.2);
}

/* STARS */

.testimonial-rating{
  display:flex;
  gap:5px;
}

.testimonial-rating i{
  color:#F0C95C;
  font-size:1rem;
}

/* TEXT */

.testimonial-text{
  font-size:1rem;
  line-height:1.9;
  color:#6b7280;
  margin-bottom:30px;
  position:relative;
}

/* CLIENT */

.testimonial-client h4{
  font-size:1.15rem;
  font-weight:700;
  color:#0F2B45;
  margin-bottom:5px;
}

.testimonial-client span{
  color:#9ca3af;
  font-size:0.95rem;
}

/* RESPONSIVE */

@media(max-width:768px){

  .testimonials-section{
    padding:80px 0;
  }

  .testimonials-grid{
    grid-template-columns:1fr;
  }

  .testimonial-card{
    padding:35px 25px;
  }

}


/* =========================
   PARTNERS SECTION
========================= */

.partners-section{
  position:relative;
  overflow:hidden;
  padding:110px 0;

  background:
    linear-gradient(
      180deg,
      #f8fafc 0%,
      #ffffff 100%
    );
}

/* GRID */

.partners-grid{
  display:grid;
  grid-template-columns:repeat(auto-fit,minmax(260px,1fr));
  gap:35px;
}

/* CARD */

.partner-card{
  position:relative;
  background:white;
  padding:45px 30px;
  border-radius:28px;
  text-align:center;
  overflow:hidden;

  border:1px solid rgba(15,43,69,0.05);

  box-shadow:
    0 15px 40px rgba(0,0,0,0.06);

  transition:0.5s ease;
}

/* HOVER */

.partner-card:hover{
  transform:translateY(-12px);

  box-shadow:
    0 25px 55px rgba(0,0,0,0.12);
}

/* GOLD EFFECT */

.partner-card::before{
  content:"";
  position:absolute;
  inset:0;

  background:
    linear-gradient(
      135deg,
      rgba(240,201,92,0.08),
      transparent
    );

  opacity:0;
  transition:0.5s;
}

.partner-card:hover::before{
  opacity:1;
}

/* ICON */

.partner-icon{
  width:90px;
  height:90px;

  margin:auto;
  margin-bottom:25px;

  display:flex;
  align-items:center;
  justify-content:center;

  border-radius:24px;

  background:
    linear-gradient(
      135deg,
      #0F2B45,
      #1f4b6b
    );

  color:#F0C95C;
  font-size:2.3rem;

  box-shadow:
    0 12px 28px rgba(15,43,69,0.2);

  transition:0.4s;
}

.partner-card:hover .partner-icon{
  transform:rotate(-6deg) scale(1.08);
}

/* TITLE */

.partner-card h3{
  font-size:1.3rem;
  font-weight:700;
  color:#0F2B45;
  margin-bottom:15px;
}

/* TEXT */

.partner-card p{
  color:#6b7280;
  line-height:1.8;
  font-size:1rem;
}

/* RESPONSIVE */

@media(max-width:768px){

  .partners-section{
    padding:80px 0;
  }

  .partners-grid{
    grid-template-columns:1fr;
  }

  .partner-card{
    padding:35px 25px;
  }

}

/* ABOUT SECTION */

.about{
padding:100px 0;
position:relative;
overflow:hidden;
}

.about-grid{
display:grid;
grid-template-columns:1fr 1fr;
gap:60px;
align-items:center;
}

/* IMAGE */

.about-image{
position:relative;
}

.about-image img{
width:100%;
border-radius:25px;
box-shadow:0 20px 40px rgba(0,0,0,0.15);
transition:all 0.5s ease;
}

.about-image img:hover{
transform:scale(1.03) rotate(-1deg);
}

/* TEXT */

.about-text{
position:relative;
z-index:2;
}

.section-badge{
display:inline-block;
background:rgba(240,201,92,0.15);
color:#F0C95C;
padding:10px 18px;
border-radius:30px;
font-size:0.85rem;
font-weight:700;
letter-spacing:1px;
margin-bottom:20px;
}

.section-title{
font-size:2.5rem;
font-weight:800;
margin-bottom:25px;
color:#0F2B45;
line-height:1.2;
}

.about-description{
font-size:1.05rem;
line-height:1.9;
color:#4b5563;
margin-bottom:20px;
}

/* FEATURES */

.about-features{
display:grid;
grid-template-columns:1fr 1fr;
gap:15px;
margin:35px 0;
}

.feature-item{
display:flex;
align-items:center;
gap:10px;
font-weight:500;
color:#0F2B45;
}

.feature-icon{
width:28px;
height:28px;
display:flex;
align-items:center;
justify-content:center;
background:#F0C95C;
color:#0F2B45;
border-radius:50%;
font-size:0.9rem;
font-weight:bold;
}

/* BUTTON */

.about-btn{
display:inline-flex;
align-items:center;
justify-content:center;
padding:14px 32px;
border-radius:50px;
font-weight:700;
transition:0.3s;
}

.about-btn:hover{
transform:translateY(-3px) scale(1.03);
}

/* RESPONSIVE */

@media(max-width:768px){

.about-grid{
grid-template-columns:1fr;
gap:40px;
}

.section-title{
font-size:2rem;
text-align:center;
}

.about-text{
text-align:center;
}

.about-features{
grid-template-columns:1fr;
}

.feature-item{
justify-content:center;
}

.section-badge{
margin:auto;
margin-bottom:20px;
display:inline-block;
}

}
.recrutement-banner{
  background: linear-gradient(90deg,#F0C95C,#FFD166);
  color:#0F2B45;
  padding:6px 0; /* ↓ réduit la hauteur */
  font-weight:600;
  font-size:0.85rem; /* ↓ texte plus compact */
}

.recrutement-banner .container{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:10px; /* ↓ moins d’espace */
}

.recrutement-banner i{
  font-size:1.2rem; /* icône plus compacte */
}

.recrutement-banner .text{
  display:flex;
  flex-direction:column;
  font-size:0.8rem;
  line-height:1.2; /* ↓ réduit hauteur texte */
}

.recrutement-banner .btn{
  background:#0F2B45;
  color:white;
  padding:6px 14px; 
  border-radius:30px;
  text-decoration:none;
  font-size:0.8rem;
  white-space:nowrap;
}
</style>